import { api, ApiResponse } from './api';

export interface Attachment {
  id: string;
  item_id: string;
  uploaded_by: string;
  filename: string;
  original_name: string;
  mime_type: string;
  size: number;
  url: string;
  path: string;
  created_at: string;
}

export const attachmentApi = {
  getAll: async (workspaceId: string, itemId: string): Promise<Attachment[]> => {
    const response = await api.get<ApiResponse<Attachment[]>>(
      `/api/v1/workspaces/${workspaceId}/items/${itemId}/attachments`
    );
    return response.data.data || [];
  },

  upload: async (workspaceId: string, itemId: string, file: File): Promise<Attachment> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post<ApiResponse<Attachment>>(
      `/api/v1/workspaces/${workspaceId}/items/${itemId}/attachments`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data.data!;
  },

  delete: async (workspaceId: string, itemId: string, attachmentId: string): Promise<void> => {
    await api.delete(
      `/api/v1/workspaces/${workspaceId}/items/${itemId}/attachments/${attachmentId}`
    );
  },
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const isImageMime = (mime: string): boolean => {
  return mime.startsWith('image/');
};
